import {FormWrapper, SubmitBtnMerchant} from "../../../../../helpers/FormHandlers";
import {FIELDS_LIST} from "./constants";
import {Box, CircularProgress, Grid} from "@material-ui/core";
import {MerchantSwitch} from "../../../../../helpers/InputsHelpers";
import React from "react";
import {apiV2NotificationGet, apiV2NotificationSet} from "../../../../../../api/merchant/notification";
import LabelDisplay from "../../../../../helpers/InputsHelpers/merchant/LabelDisplay";

export default () => {
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    setLoading(true);

    apiV2NotificationGet()
        .then(setData)
        .finally(() => {
          setLoading(false);
        })
  }, []);

  if (loading) {
    return (
      <Box>
        <CircularProgress size="2.5rem" color="inherit" />
      </Box>
    )
  }

  return (
    <FormWrapper
      data={data}
      onSubmit={apiV2NotificationSet}
      resultModalData={['Notification settings have been changed']}
    >{(formCtx) => (
      <>
        <Grid container spacing={4}>
          {FIELDS_LIST.map(({groupTitle, list}, i) => (
            <Grid key={i} item md={6} xs={12}>
              <Box mb="1rem">
                <LabelDisplay label={groupTitle} />
              </Box>
              {list.map((el, i) => (
                <MerchantSwitch
                  key={i}

                  name={el.id}
                  text={el.text}

                  formCtx={formCtx}
                  disableLabel
                />
              ))}
            </Grid>
          ))}
        </Grid>
        <Box maxWidth="27rem" mt="3.4rem">
          <SubmitBtnMerchant formCtx={formCtx}>
            Save Notifications
          </SubmitBtnMerchant>
        </Box>
      </>
    )}</FormWrapper>
  )
}
